import { Box, Paper, Typography } from '@mui/material';
import React from 'react';

import CheckpointInput from './CheckpointInput';
import CheckpointsFound from './CheckpointsFound';

const Home: React.FC = () => {
  return (
    <Box sx={{ mt: 4 }}>
      <Paper elevation={3} sx={{ p: 1 }}>
        <img className="checkpoint-image" src="/images/checkpoints/cover.jpg" />
        <Typography variant="h4" component="h1" gutterBottom>
          Suunnistus!
        </Typography>
        <Typography variant="body1">
          <p>
            Tiedossa on salapoliisityötä ja tarkkoja silmiä! Alueella on
            piilossa 10 rastia, joista jokainen johdattaa sinut seuraavan
            jäljille.
          </p>
          <p>
            Jokaisella rastilla odottaa vihje – pieni arvoitus, joka kertoo,
            minne suunnata seuraavaksi. Kun löydät viimeisen rastin, olet
            suorittanut koko reitin – ehkä jotain pientä yllätyskin odottaa
            lopussa... 😉
          </p>
          <p>
            Muista tutkia tarkkaan, miettiä vihjeitä yhdessä ja pitää hauskaa
            matkalla! 🎒🔍
          </p>
        </Typography>
      </Paper>{' '}
      <Paper elevation={3} sx={{ mt: 2, mb: 2, p: 1, pb: 4 }}>
        <Typography variant="body1">
          <p>Aloita kirjoittamalla rastin numero tähän:</p>
        </Typography>
        <CheckpointInput />
      </Paper>
      <Paper elevation={3} sx={{ mt: 2, mb: 4, p: 1 }}>
        <CheckpointsFound />
      </Paper>
    </Box>
  );
};

export default Home;
